export const scanningTimeout = 30 * 1000;
export const otherTimeout = 30;

export const socketIdTypeOption = {
  discovery: "discovery",
  stopDiscovery: "stopDiscovery",
  auth: "auth",
  adopt: "adopt",
};

export const scopeLevelOption = {
  msp: "msp",
  org: "org",
  site: "site",
};

export const authStateOption = {
  passed: "passed",
  failed: "failed",
  unknown: "unknown",
};

export const deviceStatusOption = {
  unmanaged: {
    label: "Unmanaged",
    value: "unmanaged",
  },
  configurable: {
    label: "Configurable",
    value: "configurable",
  },
  authenticationRequired: {
    label: "Authentication Required",
    value: "authenticationRequired",
  },
  provisioning: {
    label: "Provisioning",
    value: "provisioning",
  },
};

export const adoptionSourceType = {
  byRow: "byRow",
  byCheckboxWithAuthenticate: "byCheckboxWithAuthenticate",
  byCheckboxWithAdoption: "byCheckboxWithAdoption",
};

export const surveillanceDeviceTypeOption = {
  nvr: { label: "NVR", value: "NVR" },
  ipcam: { label: "Camera", value: "ipcam" },
  unknown: { label: "Unknown", value: "unknown" },
};

export const surveillanceProductCategoryOption = {
  nvr: "Network Video Recorder",
  ipcam: "IP Camera",
};

export const defaultDiscoveryProtocol = "onvif";
export const defaultProtocolType = "sunell";
